module.exports = __webpack_public_path__ + "static/media/chrome.22673265.svg";